import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  content: () => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;

    svg {
      max-width: 170px;
      max-height: 170px;
    }
  `,

  text: () => css`
    width: 100%;
  `,

  footer: () => {
    return css`
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
      gap: 8px;

      @media (max-width: 639px) {
        flex-direction: column;
        button {
          width: 100%;
        }
      }
    `
  },
})

export { useStyles }
